import {Product} from '@mintdata-wsp/common/controllers/network/generated/responses/Product';

export class ProductUtil
{
    public static isEqual(p1:Product, p2:Product):boolean
    {
        return p1 && p2 && p1.productId === p2.productId;
    }
}
